import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={134}
      height={24}
      viewBox="0 0 134 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M0 6c0-3.314 2.758-6 6.16-6H127.84C131.242 0 134 2.686 134 6v3c-1.701 0-3.08 1.343-3.08 3s1.379 3 3.08 3v3c0 3.314-2.758 6-6.161 6H6.161C2.758 24 0 21.314 0 18v-3c1.701 0 3.08-1.343 3.08-3S1.701 9 0 9V6z"
        fill={props?.color ? props.color : "#00AB59"}
        fillOpacity={0.05}
      />
    </Svg>
  );
}

export default SvgComponent;
